<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2gQDgV/tc-custom/9781504004435.jpg?1705606893929" alt="This image is the cover for the book Al(exandra) the Great, Al"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Al(exandra) the Great, Al
      </h1>
      <p class="bookDescription body article font2">
        <b>An exciting summer with Al’s father awaits—but when her mom gets sick, Al has to decide what’s most important</b><br/><br/> Al can’t wait to visit her father’s family for an entire month. They’ve promised her homemade ice cream and a barn dance that even the boy she likes is coming to! Nothing can stop her from having the best summer of her life—that is, if she can quit worrying about leaving her mother, who hasn’t been feeling well for weeks. Al wants to be a good daughter to both parents, but who will take care of her mother while she’s gone?<br/><br/> Life is about to get a little complicated, but deep down, Al knows what she has to do.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Constance C. Greene
      </h2>
      
      <p class="authorDescription body article">Constance C. Greene was the author of over twenty highly successful children&rsquo;s and young adult novels, including the ALA Notable Book <I>A Girl Called Al</I>, <I>Al(exandra) the Great</I>, <I>Getting Nowhere</I>, and <I>Beat the Turtle Drum</I>, which is an ALA Notable Book, an IRA-CBC Children&rsquo;s Choice, and the basis for the Emmy Award&ndash;winning after-school special <I>Very Good Friends</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33cca724